<template>
	<div class="boxBg">
		<h4>{{ analysisData.title }}</h4>
		<p v-for="(item, index) in analysisData.dataArrayList" :key="index">{{ item }}</p>
	</div>
</template>

<script>
export default {
	props: {
		analysisData: {
			type: Object //可指定接收类型，如:Array.
		}
	},
	data() {
		return {};
	}
};
</script>

<style scoped="scoped" lang="scss">
.boxBg {
	margin-top: 20px;
	background-color: #ffffff;
	padding: 10px;
}
h4 {
	text-align: left;
	   color: #f36625;
}
</style>
